module.exports = __webpack_public_path__ + "static/fonts/OpenSans-Regular.a887487.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/fonts/OpenSans-Regular/OpenSans-Regular.ttf
// module id = ArQb
// module chunks = 17